<div class="form-group">
    <select class="select-form-control" [id]="cardId"
        [(ngModel)]="selectedCard"
        [class.form-error] = "hasError"
        [class.focused] ="selectedCard"
        value="" (change)= "sendParentNotification($event)"
        (focus)="selectFirst()">
        <option style="direction: ltr;" *ngFor="let card of cardList;let i= index" [ngValue]="card">
            <span style="font-family: 'novin_number'">{{card.pan}}</span><span> {{card.title}} </span>
        </option>
    </select>
    <span class="floating-label">انتخاب کارت مبدا</span>
    <span class="star">*</span>
    <span *ngIf="hasError" class="errorInput">پر کردن این فیلد الزامی است.</span>
</div>
